import { render, staticRenderFns } from "./LessonExtraCombined.vue?vue&type=template&id=7e462493&"
import script from "./LessonExtraCombined.vue?vue&type=script&lang=js&"
export * from "./LessonExtraCombined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports